import { setUser, setContext , setTag } from "@sentry/react";

export async function sentryMetaData(currentUser, currentOrg) {
    setUser({
        id: currentUser.id,
        username: currentUser.username,
        orgId: currentOrg.id,
        orgName: currentOrg.name,
        school_name: currentOrg.displayName,
        role: currentUser.role,
    });
    setContext("user", {
        id: currentUser.id,
        username: currentUser.username,
        org_id: currentOrg.id,
        district_id: currentOrg.parent ? currentOrg.parent.id : null,
        school_name: currentOrg.displayName,
        role: currentUser.role,
    });
    setTag("user_id", currentUser.id);
    setTag("username", currentUser.username);
    setTag("org_id", currentOrg.id);
}